import { Accordion, Box, Divider, Text } from '@mantine/core';
import {
  IconBasketStar,
  IconChecklist,
  IconFileSearch,
  IconFileText,
  IconList,
  IconUserUp,
  IconVolume,
} from '@tabler/icons-react';
import { useFactFind } from 'src/fact-find/FactFindProvider';
import { useSuitability } from 'src/suitability-report/SuitabilityProvider';
import { useMeetingNote } from 'src/meeting-note/MeetingNoteProvider';
import Suggestion from '../Suggestion';

export const SUGGESTIONS_ACCORDION_KEY = 'suggestions';

type ChatSuggestionsProps = {
  expandedAccordionItem: string | null;
  setExpandedAccordionItem: (value: string | null) => void;
  onCreateAgenda: () => void;
};

export default function ChatSuggestions({
  expandedAccordionItem,
  setExpandedAccordionItem,
  onCreateAgenda,
}: ChatSuggestionsProps) {
  const { open: openSuitabilityFlow } = useSuitability();
  const { open: openFactFindFlow } = useFactFind();
  const { open: openMeetingNoteFlow } = useMeetingNote();

  const handleCreateSuitabilityReport = () => {
    openSuitabilityFlow();
  };

  const handleCreateFactFind = () => {
    openFactFindFlow();
  };

  const handleCreateMeetingNote = () => {
    openMeetingNoteFlow();
  };

  return (
    <Box mb="md">
      <Accordion value={expandedAccordionItem} onChange={setExpandedAccordionItem}>
        <Accordion.Item
          role="region"
          key={SUGGESTIONS_ACCORDION_KEY}
          value={SUGGESTIONS_ACCORDION_KEY}
        >
          <Accordion.Control py={'sm'}>
            <Text ml={'xxs'} size={'md'} fw={600}>
              Suggestions for you
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <Suggestion
              Icon={IconList}
              title={'Meeting agenda'}
              description={'Includes client summary and topics for discussion'}
              onClick={onCreateAgenda}
            />
            <Divider my={'xs'} />
            <>
              <Suggestion
                Icon={IconVolume}
                title={'Meeting note'}
                description={'Generate notes from meeting recordings'}
                onClick={handleCreateMeetingNote}
              />
              <Divider my={'xs'} />
            </>
            <Suggestion
              Icon={IconChecklist}
              title={'Create fact find'}
              description={"Export a fact find document populated with the client's data"}
              onClick={handleCreateFactFind}
            />
            <Divider my={'xs'} />
            <Suggestion
              Icon={IconFileSearch}
              title={'Data health check'}
              description={
                'To see how up-to-date client data is, check for missing data and get recommendations for improvement'
              }
              isPreview
            />
            <Divider my={'xs'} />
            <Suggestion
              Icon={IconUserUp}
              title={'Meeting summary table'}
              description={
                'Categories clients by last meeting date with more details for clients not seen in over 9 months.'
              }
              isPreview
            />
            <Divider my={'xs'} />
            <Suggestion
              Icon={IconBasketStar}
              title={'Opportunities'}
              description={
                'Suggested list of opportunities to help your client for consideration and discussion with your client.'
              }
              isPreview
            />
            <Divider my={'xs'} />
            <Suggestion
              Icon={IconFileText}
              title={'Suitability report'}
              description={
                'Generate a suitability report for your client based on the information we currently hold.'
              }
              onClick={handleCreateSuitabilityReport}
            />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
}
